import React, { ChangeEvent, ReactElement, useState, useRef, useEffect } from "react";
import style from "./pageHeader.module.css";

interface PageHeaderProps {
  title: string;
  searchQuery: string;
  setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
  showSearchButton: boolean;
  showAdditionalButton: boolean;
  buttonTitle: string;
  onClick?: () => void;
  isGridView?: boolean;
  onGridIconClick?: () => void;
  showFilterButton?: boolean;
  dropdownContent?: React.ReactNode; // New prop for dropdown content
}

const PageHeader = ({
  title,
  searchQuery,
  setSearchQuery,
  showSearchButton,
  showAdditionalButton,
  buttonTitle,
  onClick,
  onGridIconClick,
  isGridView = false,
  showFilterButton = true,
  dropdownContent, // Include dropdownContent prop
}: PageHeaderProps): ReactElement => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const filterButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        filterButtonRef.current &&
        !filterButtonRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prevState) => !prevState);
  };


  const handleSearchChange = (e: ChangeEvent<HTMLInputElement>): void => {
    setSearchQuery(e.target.value);
  };

  return (
    <div className={style.divBodyHeading}>
      <div className={style.headerContent}>
        <p className={style.bodyTitle}>{title}</p>
      </div>

      <div className={style.rightContent}>
        <button
          className={`${style.gridIcon} ${isGridView ? 'fa fa-list' : 'fa fa-th-large'}`}
          onClick={onGridIconClick}
        />
            {showFilterButton && (
          <>
            <button
              ref={filterButtonRef}
              className={`${style.filterIcon} fa fa-filter`}
              onClick={handleDropdownToggle}
            />
            {isDropdownOpen && dropdownContent && (
              <div ref={dropdownRef} className={style.dropdown}>
                {dropdownContent}
              </div>
            )}
          </>
        )}
        {showSearchButton && (
          <div className={style.searchContainer}>
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              className={style.inputSearch}
              onChange={handleSearchChange}
            />
            <button className={`fa fa-search ${style.searchIcon}`} />
          </div>
        )}

        {showAdditionalButton && (
          <button className={style.newUserButton} onClick={onClick}>
            {buttonTitle}
          </button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
